import {
  ASSIGN_ACCESS_REQUEST,
  GET_INTERNAL_ACCESS_REQUESTS,
  receiveInternalAccessRequests,
} from "@/components/access/internal/ducks/Actions"
import {
  apiAssignAccessRequest,
  apiGetInternalAccessRequests,
} from "@/components/access/internal/ducks/AJAX"

export default (store) => (next) => (action) => {
  const { dispatch } = store

  const receiveInternalAccessRequestsSuccess = (cb) => (resp) => {
    dispatch(receiveInternalAccessRequests(resp.networkAccessRequests))
    if (cb) {
      cb()
    }
  }

  switch (action.type) {
    case ASSIGN_ACCESS_REQUEST:
      apiAssignAccessRequest(
        action.params,
        receiveInternalAccessRequestsSuccess(action.success),
        action.error,
      )
      return next(action)

    case GET_INTERNAL_ACCESS_REQUESTS:
      apiGetInternalAccessRequests(
        receiveInternalAccessRequestsSuccess(action.success),
        action.error,
      )
      return next(action)

    default:
      return next(action)
  }
}
